export const EMPTY_FORM = {
    class_date: '',
    bell_id: '',
    group_id: [],
    subject_id: '',
    teacher_id: '',
    building_id: '',
    room_id: '',
    class_type_id: '',
    class_type_name: '',
}
